import { FilterOption } from "../../../../../../Components/FilterPopup/filterPopup.models";
import { AgentsFilters } from "../../../../agents.model";
import { AGENT_NAME_KEY, AGENCY_NAME_KEY, USER_TYPE_KEY } from "../../../../agents.constants";

export const getAgentsFilterOptions = (
    draftFilters: AgentsFilters,
    updateDraft: <K extends keyof AgentsFilters>(key: K, value: AgentsFilters[K]) => void,
    userTypeOptions: FilterOption["options"],
    agencyOptions: FilterOption["options"],
    agentOptions: FilterOption["options"]
): FilterOption[] => [
    {
        label: "Agency Name",
        type: "select",
        options: agencyOptions,
        value: draftFilters.agencyName,
        handleChange: (value) => updateDraft(AGENCY_NAME_KEY, value as string[]),
    },
    {
        label: "Agent Name",
        type: "select",
        options: agentOptions,
        value: draftFilters.agentName,
        handleChange: (value) => updateDraft(AGENT_NAME_KEY, value as string[]),
    },
    {
        label: "User Type",
        type: "select",
        options: userTypeOptions,
        value: draftFilters.userType,
        handleChange: (value) => updateDraft(USER_TYPE_KEY, value as string[]),
    },
];
